import { AuthService } from '../../core/services/authService/auth.service';
import { Component, HostListener } from '@angular/core';
import { UserResponse } from '../../model/user';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { LogoChangeService } from '../../core/services/logoChange/logo-change.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  public displayName = ''
  public AccountManagementLogo = '';
  public isUserDropdownOpen = false;
  public isNotificationDropdownOpen = false;
  public navbarOpen = false;
  public logo = null;
  public logoWidth = null;

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private logoChangeService: LogoChangeService
  ) {
    let userResponse: UserResponse = JSON.parse(localStorage.getItem('user'));
    if (userResponse) {
      this.displayName = userResponse.accountManager.name;
    }
    
    }

  ngOnInit() {
    this.getBankLogo();
    this.logoChangeService.logoUrl$.subscribe((url) => {
      if (url !== null) {
        this.AccountManagementLogo = url;
        const img = new Image();
        img.onload = () => {
          this.logoWidth = img.width;
        };
        img.src = this.AccountManagementLogo;
      } else {
        this.getBankLogo();
      }
    });
  }

  get isMobile() {
    return window.innerWidth <= 768;
  }

  get loggedIn() {
    if (localStorage.getItem('user') !== null && this._router.url !== '/login') {
      return true;
    } else {
      return false;
    }
  }
  public onLogoutDropdownClicked() {
    this.isUserDropdownOpen = !this.isUserDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const clickedInside = target.closest('#header_user');
    if (!clickedInside) {
      this.isUserDropdownOpen = false;
    }
  }

  public onNotificationDropdownClicked() {
    this.isNotificationDropdownOpen = !this.isNotificationDropdownOpen;
  }

  public getBankLogo() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.accountManager && user.accountManager.logoName) {
      this.AccountManagementLogo = environment.AZURE_STORAGE_URL + user.accountManager.logoName;
        const img = new Image();
        img.onload = () => {
            // The actual image height is img.height (e.g., 94px), but displayed at 40px.
            // Adjust width to maintain aspect ratio: displayedWidth = (img.width / img.height) * 40
            this.logoWidth = (img.width / img.height) * 40;
            console.log('Adjusted logo width for 40px height:', this.logoWidth);
            console.log('Original logo width:', img.width);
            console.log('Original logo height:', img.height);
        };
        img.src = this.AccountManagementLogo;
        console.log(this.logoWidth);
    } else {
      this.AccountManagementLogo = null;
    }
  }

  public logout() {
    this.displayName = '';
    this.isUserDropdownOpen = false;
    this.isNotificationDropdownOpen = false;
    this._authService.logOut();
    this._router.navigate(['/loggedOut']);
  }

  public toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

}
